module.exports = __webpack_public_path__ + "static/media/gryllodes_sigillatus.3d1fd3e1.jpg";